import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, CheckCircle2Icon } from 'lucide-react';
import { ContactSection } from '../ContactSection';
const INFO_ITEMS = [{
  icon: <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-180" />,
  label: '拠点',
  value: '神奈川県横須賀市（地域密着で対応）'
}, {
  icon: <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-181" />,
  label: 'お電話',
  value: '046-000-0000（平日 9:00〜18:00）'
}, {
  icon: <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-182" />,
  label: 'メール',
  value: 'hello@optidsa.example'
}];
export function ContactBand() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async (data: {
    name: string;
    email: string;
    message: string;
  }) => {
    try {
      await fetch('https://script.google.com/macros/s/AKfycbwOEFv5sXD1vMKDLihmprv1Hi5pW5Jj-Csbs4sHzhbM8phq32E0V00bYWOq-3VlQTdB/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: JSON.stringify(data)
      });
      setSubmitted(true);
    } catch (error) {
      console.error('送信エラー:', error);
      setSubmitted(true); // エラー時も一旦完了画面を表示します
    }
  };
  return <ContactSection id="contact" className="scroll-mt-24" eyebrow="お問い合わせ" title={submitted ? <span className="inline-flex items-center gap-2" data-id="element-184">
            <CheckCircle2Icon className="h-7 w-7 text-sage-green" aria-hidden="true" data-id="element-185" />
            お問い合わせありがとうございます
          </span> : 'OptiDSAの伴走支援について'} description={submitted ? '内容を確認のうえ、担当者よりご連絡いたします。' : '現在、新規の無料体験・無料デモの受付は一時停止しています。サービス内容や既存の伴走支援についてのご質問は、こちらからお寄せください。'} infoItems={INFO_ITEMS} submitLabel="お問い合わせを送信" onSubmit={handleSubmit} data-id="element-183" />;
}